import React, {
  createContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import CustomToastContent from "../components/CustomToastContent";
import ErrorIcon from "../images/error_icon.svg";
import { getCookie } from "../utils/cookieUtils";
const ws_token = getCookie("ws_token");
const client_id = getCookie("client_id");

const ABWebSocketContext = createContext(null);

const ABWebSocketProvider = ({ children }) => {
  const location = useLocation();
  const conn = useRef(null);
  const previousPathname = useRef(null);
  const [symbolList, setSymbolList] = useState([]);
  const [readyState, setReadyState] = useState(false);
  const [symbolData, setSymbolData] = useState({});
  const [msg, setMsg] = useState({});
  const [exchangeMap, setExchangeMap] = useState(new Map());
  const [reconnectAttempts, setReconnectAttempts] = useState(0);
  const [requestSent, setRequestSent] = useState(false);
  const [connectionInProgress, setConnectionInProgress] = useState(false);
  const [needsResubscription, setNeedsResubscription] = useState(false);
  const [isResubscribing, setIsResubscribing] = useState(false);

  //const MARKET_DATA_URL = `wss://f5zy.aliceblueonline.com/`;
  const MARKET_DATA_URL = `wss://ws1.aliceblueonline.com/NorenWS/`;

  // useEffect(() => {
  //   if (msg) {
  //     setSymbolData((prevData) => ({
  //       ...prevData,
  //       [Object.keys(msg)]: msg[Object.keys(msg)],
  //     }));
  //   }
  // }, [msg, tempsymbolData]);

  useEffect(() => {
    // TODO: Uncomment heart beat
    setInterval(() => {
      checkWebsocketConnection();

      if (conn.current.readyState === WebSocket.OPEN && readyState) {
        var initCon = {
          k: "",
          t: "h",
        };
        conn.current.send(JSON.stringify(initCon));
      }
      if (conn.current.readyState === WebSocket.CLOSED) {
        setReadyState(false);
      }
    }, 5000);

    return () => {};
  }, [readyState]);

  useLayoutEffect(() => {
    handleNavigation();
    // TODO: Uncomment heart beat
    return () => {};
  }, [location.pathname, readyState, symbolList]);

  // Effect to handle resubscription when readyState becomes true after a reconnection
  useEffect(() => {
    if (readyState && needsResubscription && !isResubscribing && exchangeMap.size > 0) {
      // console.log("Connection ready after reconnection, resubscribing to symbols:", exchangeMap);
      setIsResubscribing(true);
      
      // Resubscribe to all symbols when connection is ready after reconnection
      exchangeMap.forEach((codes, exchange) => {
        if (codes.length > 0) {
          // console.log(`Resubscribing to ${codes.length} symbols for exchange: ${exchange}`);
          // Use setTimeout to ensure the connection is fully established
          setTimeout(() => {
            resubscribeToSymbols(codes, exchange);
          }, 200);
        }
      });
      
      // Reset the resubscription flag after a delay to ensure all subscriptions are processed
      setTimeout(() => {
        setNeedsResubscription(false);
        setIsResubscribing(false);
      }, 1000);
    }
  }, [readyState, needsResubscription, isResubscribing]);

  // useEffect(() => {
  //   conn.current.onmessage = async (event) => {
  //     let decodedMsg = JSON.parse(event.data);

  //     if (decodedMsg["t"] === "ck") {
  //       setReadyState(true);
  //       setSymbolData({});
  //     }
  //     if (Object.keys(symbolList).length !== 0) {
  //       // try {
  //       let ltp_value = decodedMsg.hasOwnProperty("lp")
  //         ? parseFloat(decodedMsg?.lp).toFixed(2)
  //         : symbolData[decodedMsg.tk]?.ltp;
  //       let open_value = decodedMsg.hasOwnProperty("o")
  //         ? parseFloat(decodedMsg?.o).toFixed(2)
  //         : symbolData[decodedMsg.tk]?.open;
  //       let high_value = decodedMsg.hasOwnProperty("h")
  //         ? parseFloat(decodedMsg?.h).toFixed(2)
  //         : symbolData[decodedMsg.tk]?.high;
  //       let low_value = decodedMsg.hasOwnProperty("l")
  //         ? parseFloat(decodedMsg?.l).toFixed(2)
  //         : symbolData[decodedMsg.tk]?.low;
  //       let change_value = decodedMsg.hasOwnProperty("cv")
  //         ? parseFloat(decodedMsg?.cv).toFixed(2)
  //         : symbolData[decodedMsg.tk]?.change;
  //       let changeper_value = decodedMsg.hasOwnProperty("pc")
  //         ? parseFloat(decodedMsg?.pc).toFixed(2)
  //         : symbolData[decodedMsg.tk]?.change_per;
  //       let oi_value = decodedMsg.hasOwnProperty("oi")
  //         ? parseFloat(decodedMsg?.oi).toFixed(2)
  //         : symbolData[decodedMsg.tk]?.oi;
  //       let prev_close = decodedMsg.hasOwnProperty("c")
  //         ? parseFloat(decodedMsg?.c).toFixed(2)
  //         : symbolData[decodedMsg.tk]?.prev_close;
  //       let lot_size = decodedMsg.hasOwnProperty("ls")
  //         ? parseFloat(decodedMsg?.ls).toFixed(2)
  //         : symbolData[decodedMsg.tk]?.lot_size;
  //       let volume = decodedMsg.hasOwnProperty("v")
  //         ? parseFloat(decodedMsg?.v).toFixed(2)
  //         : symbolData[decodedMsg.tk]?.volume;
  //       let required_format = {
  //         [decodedMsg.tk]: {
  //           ltp: ltp_value,
  //           change: (ltp_value - prev_close).toFixed(2),
  //           change_per: changeper_value,
  //           open: open_value,
  //           high: high_value,
  //           low: low_value,
  //           oi: oi_value,
  //           prev_close: prev_close,
  //           lot_size: lot_size,
  //           volume: volume,
  //         },
  //       };
  //       setSymbolData((prevData) => ({
  //         ...prevData,
  //         [Object.keys(required_format)]:
  //           required_format[Object.keys(required_format)],
  //       }));
  //     }
  //   };

  // }, [symbolList, readyState, symbolData]);

  //logout function
  const handleLogout = (message = "Session expired. Please login again.") => {
    localStorage.clear();
    toast.error(
      <CustomToastContent heading={"Session expired!"} message={message} />,
      {
        className: "custom-error-toast",
        icon: <img src={ErrorIcon} alt="Error Icon" />,
      }
    );

    setTimeout(() => {
      window.location.href = "https://1lyoptions.com";
    }, 1500);
  };

  useEffect(() => {
    let attempts = 0;
    const maxAttempts = 8;
    const retryInterval = 1000;

    const checkCredentials = () => {
      if (ws_token && client_id) return;
      attempts += 1;

      if (attempts >= maxAttempts) {
        // handleLogout("Missing credentials. Please login again.");
      } else {
        setTimeout(checkCredentials, retryInterval);
      }
    };

    checkCredentials();
  }, []);

  useEffect(() => {
    if (conn.current) {
      conn.current.onmessage = (event) => {
        const decodedMsg = JSON.parse(event.data);

        //comment this in development so we don't have to set the keys again and again in local storage
        if (decodedMsg.t === "ck" && decodedMsg.s === "NOT_OK") {
          setTimeout(() => {
            handleLogout("Your session has expired. Please login again.");
          }, 4500);
          return;
        }

        if (decodedMsg.t === "ck" && decodedMsg.s === "OK") {
          setReadyState(true);
          setReconnectAttempts(0); // Reset reconnect attempts on successful connection
          // Check if this is a reconnection (connection was previously closed)
          if (needsResubscription) {
            // console.log("Reconnection successful, will resubscribe to symbols");
          }
          // setSymbolData({});
        }
        
        // Reset requestSent flag when we receive any connection response
        if (decodedMsg.t === "ck") {
          setRequestSent(false);
        }

        if (decodedMsg.tk && Object.keys(symbolList).length !== 0) {
          setSymbolData((prevData) => {
            const token = decodedMsg.tk;
            const previousSymbolData = prevData[token] || {};

            // Base data processing
            const ltp =
              decodedMsg.lp?.toString() || previousSymbolData.ltp || "0.0";
            const prevClose =
              decodedMsg.c?.toString() ||
              previousSymbolData.prev_close ||
              "0.0";
            const change = (parseFloat(ltp) - parseFloat(prevClose)).toFixed(2);
            const changePer = (
              (parseFloat(change) / parseFloat(prevClose)) *
              100
            ).toFixed(2);

            // Market depth data extraction with proper fallback handling
            const marketDepthData = {};
            for (let i = 1; i <= 5; i++) {
              marketDepthData[`bp${i}`] =
                decodedMsg[`bp${i}`]?.toString() ||
                previousSymbolData[`bp${i}`] ||
                "0.0";
              marketDepthData[`sp${i}`] =
                decodedMsg[`sp${i}`]?.toString() ||
                previousSymbolData[`sp${i}`] ||
                "0.0";
              marketDepthData[`bq${i}`] =
                decodedMsg[`bq${i}`]?.toString() ||
                previousSymbolData[`bq${i}`] ||
                "0";
              marketDepthData[`sq${i}`] =
                decodedMsg[`sq${i}`]?.toString() ||
                previousSymbolData[`sq${i}`] ||
                "0";
            }

            return {
              ...prevData,
              [token]: {
                // Core data
                ltp: ltp,
                prev_close: prevClose,
                change: change,
                change_per: changePer,

                // Other fields with proper fallbacks
                open:
                  decodedMsg.o?.toString() || previousSymbolData.open || "0.0",
                high:
                  decodedMsg.h?.toString() || previousSymbolData.high || "0.0",
                low:
                  decodedMsg.l?.toString() || previousSymbolData.low || "0.0",
                volume:
                  decodedMsg.v?.toString() ||
                  previousSymbolData.volume ||
                  "0.0",
                oi: decodedMsg.oi?.toString() || previousSymbolData.oi || "0.0",

                // Market depth data
                ...marketDepthData,

                // Additional fields
                ltq:
                  decodedMsg.ltq?.toString() || previousSymbolData.ltq || "0",
                ap: decodedMsg.ap?.toString() || previousSymbolData.ap || "0.0",
                ltt: decodedMsg.ltt?.toString() || previousSymbolData.ltt || "",
                uc: decodedMsg.uc?.toString() || previousSymbolData.uc || "0.0",
                lc: decodedMsg.lc?.toString() || previousSymbolData.lc || "0.0",
                tick_size:
                  decodedMsg.ti?.toString() || previousSymbolData.ti || "0.05",
                previous_oi:
                  decodedMsg.poi?.toString() ||
                  previousSymbolData.previous_oi ||
                  "0",
              },
            };
          });
        }
        conn.current.onclose = () => {
          // console.log("socket closed");
          setReadyState(false);
          setRequestSent(false); // Reset request sent flag
          // Set resubscription flag when connection closes
          if (exchangeMap.size > 0) {
            setNeedsResubscription(true);
            // console.log("Connection closed, will resubscribe on reconnect");
          }
          if (reconnectAttempts < 3) {
            setReconnectAttempts(prev => prev + 1);
            setTimeout(() => {
              reconnect();
            }, 1000 * (reconnectAttempts + 1));
          } else {
            // handleLogout("Failed connection to the websocket.");
          }
        };

        conn.current.onerror = (err) => {
          // console.log("WebSocket error:", err);
          setReadyState(false);
          setRequestSent(false); // Reset request sent flag
          // Set resubscription flag when connection errors
          if (exchangeMap.size > 0) {
            setNeedsResubscription(true);
            // console.log("WebSocket error, will resubscribe on reconnect");
          }
          // Clear symbol list on error to avoid duplicates on reconnect
          setSymbolList([]);
          // handleLogout("WebSocket error occurred. Please login again.");
        };
      };
    }
  }, [symbolList, readyState]);

  const handleNavigation = () => {
    if (location.pathname !== previousPathname.current) {
      previousPathname.current = location.pathname;
    }
  };

  const updateSymbolList = (symbols, action) => {
    let updatedlist = {};
    if (action === "add") {
      updatedlist = symbolList.concat(symbols.map(String));
    } else {
      updatedlist = symbolList.filter(function (el) {
        return symbols.indexOf(el) < 0;
      });
    }
    setSymbolList(updatedlist);
  };

  function sendConnectionRequest() {
    if (requestSent) {
      return; // Prevent multiple connection requests
    }
    setRequestSent(true);
    var encrcptToken = ws_token;
    var initCon = {
      susertoken: encrcptToken,
      t: "c",
      actid: client_id + "_API",
      uid: client_id + "_API",
      source: "API",
    };
    conn.current.send(JSON.stringify(initCon));
  }

  const checkWebsocketConnection = () => {
    if (!conn.current) {
      openWebSocket();
    }
    if (!(conn.current.readyState === WebSocket.OPEN && readyState)) {
      waitForSocketConnection(conn.current, function () {});
    }
    if (conn.current.readyState === WebSocket.CLOSED && !readyState) {
      openWebSocket();
    }
    if (conn.current.readyState === WebSocket.OPEN) return true;
    // else return true;
  };

  const subscribeToSymbols = (symbols, exchange) => {
    // Only subscribe if we have an open connection AND we've received "s": "OK" response
    if (conn.current && conn.current.readyState === WebSocket.OPEN && readyState) {
      let uniqueKeys = symbols
        .map(String)
        .filter((symbol) => !symbolList.includes(symbol));
      let subscribe_list = exchange + "|";
      uniqueKeys.forEach((code) => {
        subscribe_list += code + "#" + exchange + "|";
      });
      
      // Update exchangeMap without triggering resubscription effect
      setExchangeMap(prevMap => {
        const newMap = new Map(prevMap);
        if (!newMap.has(exchange)) {
          newMap.set(exchange, []);
        }
        const updatedSymbols = newMap.get(exchange).concat(uniqueKeys);
        newMap.set(exchange, updatedSymbols);
        return newMap;
      });
      
      subscribe_list = subscribe_list.slice(0, -1);
      updateSymbolList(uniqueKeys, "add");
      if (uniqueKeys.length !== 0) {
        const message = JSON.stringify({
          k: subscribe_list,
          t: "d",
        });
        conn.current.send(message);
      }
    } else {
      // If connection is not ready, queue the subscription for later
      // console.log("WebSocket not ready for subscription. Connection state:", conn.current?.readyState, "Ready state:", readyState);
      // You might want to implement a retry mechanism here
    }
    return true;
  };

  const resubscribeToSymbols = (symbols, exchange) => {
    // Only resubscribe if we have an open connection AND we've received "s": "OK" response
    if (conn.current && conn.current.readyState === WebSocket.OPEN && readyState) {
      let uniqueKeys = symbols
        .map(String)
        .filter((symbol) => !symbolList.includes(symbol));
      let subscribe_list = exchange + "|";
      uniqueKeys.forEach((code) => {
        subscribe_list += code + "#" + exchange + "|";
      });
      
      subscribe_list = subscribe_list.slice(0, -1);
      updateSymbolList(uniqueKeys, "add");
      if (uniqueKeys.length !== 0) {
        const message = JSON.stringify({
          k: subscribe_list,
          t: "d",
        });
        conn.current.send(message);
      }
    } else {
      // If connection is not ready, log the issue
      // console.log("WebSocket not ready for resubscription. Connection state:", conn.current?.readyState, "Ready state:", readyState);
    }
  };

  const unsubscribeToSymbols = (symbols, exchange) => {
    // Only unsubscribe if we have an open connection AND we've received "s": "OK" response
    if (conn.current && conn.current.readyState === WebSocket.OPEN && readyState) {
      let global_symbols = [26000, 26009, 26037, 1];
      let uniqueKeys = symbols.filter(
        (symbol) => !global_symbols.includes(symbol)
      );
      
      // Update exchangeMap without triggering resubscription effect
      setExchangeMap(prevMap => {
        const newMap = new Map(prevMap);
        if (newMap.has(exchange)) {
          const updatedSymbols = newMap
            .get(exchange)
            .filter((code) => !uniqueKeys.includes(Number(code)));
          if (updatedSymbols.length === 0) {
            newMap.delete(exchange);
          } else {
            newMap.set(exchange, updatedSymbols);
          }
        }
        return newMap;
      });

      let subscribe_list = exchange + "|";
      uniqueKeys.forEach((code) => {
        subscribe_list += code + "#" + exchange + "|";
      });
      subscribe_list = subscribe_list.slice(0, -1);
      updateSymbolList(uniqueKeys, "remove");
      const message = JSON.stringify({
        k: subscribe_list,
        t: "u",
      });
      conn.current.send(message);
    } else {
      // If connection is not ready, log the issue
      // console.log("WebSocket not ready for unsubscription. Connection state:", conn.current?.readyState, "Ready state:", readyState);
    }
  };

  const reconnect = () => {
    // console.log("Attempting to reconnect...");
    if (!conn.current || conn.current.readyState !== WebSocket.OPEN) {
      conn.current = new WebSocket(MARKET_DATA_URL);
    }
    waitForSocketConnection(conn.current, function () {
      // console.log("Reconnection successful, waiting for authentication...");
      // The resubscription will happen automatically when readyState becomes true
      // and needsResubscription flag is set
      setNeedsResubscription(true);
    });
  };

  function waitForSocketConnection(socket, callback) {
    setTimeout(function () {
      if (socket.readyState === 1) {
        if (!requestSent) {
          sendConnectionRequest();
          return true;
        }
        if (callback != null) {
          callback();
        }
      } else if (socket.readyState === 0) { // CONNECTING
        // Only continue waiting if still connecting
        waitForSocketConnection(socket, callback);
      } else {
        // Connection failed or closed, don't retry
        // console.log("WebSocket connection failed or closed, state:", socket.readyState);
      }
    }, 5); // wait 5 milisecond for the connection...
  }

  const openWebSocket = () => {
    if (!conn.current || conn.current.readyState !== WebSocket.OPEN) {
      conn.current = new WebSocket(MARKET_DATA_URL);
    }
  };

  return (
    <ABWebSocketContext.Provider
      value={{
        websocketConnection: conn.current,
        checkWebsocketConnection,
        subscribeToSymbols,
        unsubscribeToSymbols,
        updateSymbolList,
        symbolList,
        symbolData, // Include the "msg" object in the context value
        readyState,
        needsResubscription,
      }}>
      {children}
    </ABWebSocketContext.Provider>
  );
};

export { ABWebSocketProvider, ABWebSocketContext as default };
